<template>
    <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs"
                   v-on="on"
                   text>
                <v-badge overlap left color="transparent">
                    <v-avatar color="info" size="40">
                        <span class="white--text text-h6">{{ Initials }}</span>
                    </v-avatar>
                </v-badge>
                <span class="hidden-sm-and-down pl-2">{{ DisplayName }}</span>
            </v-btn>
        </template>
        <v-list>
            <v-list-item @click="OpenCommunications">
                <v-list-item-icon>
                    <v-icon>fas fa-inbox</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>My Inbox</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item @click="Logout">
                <v-list-item-icon>
                    <v-icon>fas fa-sign-out-alt</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Log Out</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
    import { eventBus } from '@/main'

    import appApiMixin from '@/views/components/mixins/appApi.js'
    import ctrlOpenMixin from '@/views/components/mixins/base/ctrlOpen.js'

    export default {
        mixins: [
            appApiMixin,
            ctrlOpenMixin,
        ],
        methods: {
            OpenCommunications() {
                this.CtrlOpen('/inbox');
            },
            Logout() {
                eventBus.$emit('sign-out:keycloak:start');
            }
        }
    }
</script>
